<template>
  <a-modal v-model="showModal" class="modalContainer mobile-modal-fullscreen" :closable="false">
    <div class="d-flex align-items-center">
      <font-awesome-icon size="2x" :icon="['fal', 'times']" class="show-in-mobile font-black mr-3 font20" @click="handleCancel" />
      <h4 class="fw700 font24 gray700 mb-0">Filter Treatments</h4>
      <button class="fw700 br6 font-white py-2 px-3 font12 br6 show-in-mobile ml-auto" @click="handleApply" :style="{ background: getPrimaryColor() }">Apply Filters</button>
      <font-awesome-icon size="2x" :icon="['fal', 'times']" class="hide-in-mobile font-black ml-auto font20 cp" @click="handleCancel" />
    </div>
    <h6 class="mt-5 fw700 gray500 font16">Type of Treatments</h6>
    <div class="checkboxMain">
      <a-radio-group class="checkbox treatment-filter-radio" v-model="answer">
        <a-radio :value="'all'">All</a-radio>
        <a-radio :value="'others'">Medication</a-radio>
        <a-radio :value="'Procedure'">Procedure</a-radio>
        <a-select v-if="answer === 'Procedure'" :allowClear="true" v-model="selectedProcedureSubType" placeholder="Select type of procedure" class="procedure-select">
          <a-select-option v-for="types in procedureTypes" :key="types" :value="types"> {{ types }} </a-select-option>
        </a-select>
        <a-radio :value="'activity'">Activity</a-radio>
        <a-radio :value="'nonmedicaltreatments'">Complementary Therapy</a-radio>
        <a-radio :value="'nutrition'">Nutrition & Diet</a-radio>
      </a-radio-group>
    </div>
    <template #footer>
      <button class="fw700 br6 fw700 font14 bg-gray200 p1224 gray600" @click="handleCancel">Clear Filters</button>
      <button class="p1224 font14 fw700 br6 hide-in-mobile font-white" @click="handleApply" :style="{ background: getPrimaryColor() }">Apply Filters</button>
    </template>
  </a-modal>
</template>

<script>
export default {
  name: "TreatmentFilter",
  props: { handleAnswer: Function },
  data() {
    return {
      answer: "",
      showModal: false,
      procedureTypes: ["Laboratory", "Radiological", "Surgical", "Office"],
      selectedProcedureSubType: undefined,
    }
  },
  methods: {
    show(pst) {
      this.showModal = true
      this.answer = this.$route.query.type
      this.selectedProcedureSubType = pst
    },
    handleCancel() {
      this.handleAnswer(this.answer, this.selectedProcedureSubType, true)
      this.showModal = false
    },
    handleApply() {
      this.showModal = false
      this.handleAnswer(this.answer, this.selectedProcedureSubType)
    },
  },
}
</script>

<style lang="scss" scoped>
.checkbox,
.checkboxMain {
  display: flex;
  flex-direction: column;
  gap: 24px;
  font-weight: 400;
  font-size: 34px;
  line-height: 21px;
  color: #0f1734 !important;
}

@media screen and (max-width: 600px) {
  .bg-gray200 {
    width: 100% !important;
  }
  .font24 {
    font-size: 20px !important;
  }
}
button {
  border: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/TreatmentFilter.vue